import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';  //导入store
import { debugRouter, debugInfo } from '@/utils/debugUtils';

Vue.use(VueRouter)

/* 定义路由配置 routes */
const routes = [
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/login',
    name: '登录',
    /* 懒加载, 动态导入组件 */
    // 一次性加载所有组件可能会导致首次加载时间过长，影响用户体验。因此，可以采用懒加载的方式，在需要的时候才加载对应的组件。
    // () => import('../views/Login')是一个箭头函数，当路由被访问时，会调用这个函数。import('../views/Login')是ES6的动态导入语法，用于异步加载../views/Login组件。
    // 组件在用户首次访问登录页面时才被加载，而不是在应用初始化时就加载，从而提高了应用的性能和加载速度。
    // 箭头函数是ES6（ECMAScript 2015）中引入的一种新的函数定义语法，也称为“fat arrow”函数。它提供了一种更简洁的方式来声明函数，并且在一些情况下可以改变函数内部this的行为。
    // (parameter1, parameter2, ..., parameterN  参数列表 ) => { statements  函数体 }
    // 箭头函数示例:  let sum =     (a, b) => a + b;
    component: () => import('../views/Login')
  },
  {
    path: '/register',
    name: '注册',
    component: () => import('../views/Register')
  },
  {
    path: '/404',
    name: '404',
    component: () => import('../views/404.vue')
  }
]

/* 通过 VueRouter 激活路由 routes */
/* router 会在 main.js中被引用 */
const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_API_BASE_URL,
  routes   /*上面定义的路由 routes */
})

/**
 *  重置路由方法
 * */
export const resetRouters=()=>{
  router.matcher=new VueRouter({
    mode: 'history',
    base: process.env.VUE_APP_API_BASE_URL,
    routes     //最初定义的const routes
  })

}



/***
 *  动态路由
 *  export setRouters 导出动态路由,到登录 /login中使用;
 *  注意刷新页面会导致页面路由重置;
 *  */
export const setRouters=()=>{

  const storeMenus=localStorage.getItem("menus");
   if(storeMenus){
    // 获取当前的路由对象名称的数组; about,登录,注册,404； 也就是routers中的name;
    const currentRoutesNameArray=router.getRoutes().map(v=>v.name);

    if (!currentRoutesNameArray.includes('Manage')) {
      const manageRoute= {
        path: '/',
        name:"Manage",
        component: ()=> import('../views/Manage'),
        redirect:"/home",
        children:[
          /* manage路径是 /; http://172.16.84.44:8080/person */
          {path: 'person', name:'个人信息', component: ()=> import('../views/Person.vue')},
          /* manage路径是 /; http://172.16.84.44:8080/password */
          {path: 'password', name:'修改密码', component: ()=> import('../views/Password.vue')}
        ]
      }

      //设置动态路由
      let homeMenuExists = false;
      const menus = JSON.parse(storeMenus)

      //处理动态跻身上
      menus.forEach( (item,index)=> {

            /* 判断一级菜单,item是否存在路径就设置; 注意menus是已经格式化为一级菜单,二级菜单了 */
             if(item.path) { //就是判断是否是一级菜单;以item.path
              let itemMenu = {
                path: item.path.replace("/", ""),
                name: item.name,
                component: () => import('@/views/' + item.pagePath + '.vue')
              };

               manageRoute.children.push(itemMenu)
              // 如果菜单中包含 /home，标记为已存在
              if (item.path === '/home') {
                homeMenuExists = true;
              }
            }

             /* 增加子菜单项路径加上 parentPath */
            if(item.children.length){ //遍历子路径;
              item.children.forEach((item,index)=>{
                 if(item.path){

                     let itemMenu = {
                        path: item.path.replace("/", ""),
                        name: item.name,
                        component: () => import(
                            '../views/'+
                            (item.parentPagePath ? item.parentPagePath.replace(/\//g, '')  + '/' : '') +
                            item.pagePath +
                            '.vue'),
                      };

                     //打印路由路径;
                     debugInfo(  '../views/'+
                         (item.parentPagePath ? item.parentPagePath.replace(/\//g, '')  + '/' : '') +
                         item.pagePath + '.vue')
                      manageRoute.children.push(itemMenu)

                      // 如果子菜单中包含 /home，标记为已存在
                      if (itemMenu.path === '/home') {
                        homeMenuExists = true;
                      }
                }
              })
            }

      })

      // 如果 /home 菜单不存在，则手动添加
      if (!homeMenuExists) {
        manageRoute.children.push({
          path: 'home',
          name: '首页',
          component: () => import('../views/test/DebugInfo.vue')  // 根据实际路径调整
        });
      }
      //设置动态添加到现在路由对象中去;
      router.addRoute(manageRoute)
    }
  }
}

//在Login.vue登录后,如果重置页面,再添加一次路由
setRouters();

/* 路由守卫; 注意next()放行 */
router.beforeEach((to,from,next)=>{
  // 将来源路由名称存储在本地存储中; 以便在header中获取;
  localStorage.setItem('currentPathName', to.name);
  // console.log("路由守卫 ==> "+localStorage.getItem("currentPathName"))
  store.commit("setPath");  //触发store的数据更新; // 触发 Vuex store 的 mutation，将当前路由名称存储到 Vuex 中

  //未找到路由
  if(!to.matched.length){
    const storeMenus=localStorage.getItem("menus");
    if(storeMenus){
      return next("/404");   //说明用户已登录;有菜单没找到路由,跳到404;
    }else{
      return next("/login");  //没有登录,就跳到登录
    }
  }

  next() //放行

})

export default router
